import { useNavigate } from "react-router";

import type { ListTenantsResponse } from "@chirpstack/chirpstack-api-grpc-web/api/tenant_pb";
import { ListTenantsRequest } from "@chirpstack/chirpstack-api-grpc-web/api/tenant_pb";

import TenantStore from "../../stores/TenantStore";
import SessionStore from "../../stores/SessionStore";

function TenantRedirect() {
  const navigate = useNavigate();

  const tenantId = SessionStore.getTenantId();

  if (tenantId !== "") {
    // Set the tenantId to ensure it's in the session, then redirect to DevStat Dashboard
    SessionStore.setTenantId(tenantId);
    navigate("/devstat-dashboard");
  } else {
    const req = new ListTenantsRequest();
    req.setLimit(1);

    TenantStore.list(req, (resp: ListTenantsResponse) => {
      if (resp.getResultList().length !== 0) {
        const firstTenantId = resp.getResultList()[0].getId();
        // Set the tenantId in the session, then redirect to DevStat Dashboard
        SessionStore.setTenantId(firstTenantId);
        navigate("/devstat-dashboard");
      } else {
        // No tenants available, still redirect to DevStat Dashboard
        navigate("/devstat-dashboard");
      }
    });
  }

  return null;
}

export default TenantRedirect;
